/**
 * Client Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.2.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TagDetailsResponse } from './tagDetailsResponse';

export interface ManagementClientTagRequest {
    priority: number;
    sentiment: boolean;
    brandKind?: ManagementClientTagRequest.BrandKindEnum;
    realTime: boolean;
    realTimeEmails?: Array<string>;
    viber: boolean;
    tagType: ManagementClientTagRequest.TagTypeEnum;
    tagId: string;
    colorCode?: string;
    details?: Array<TagDetailsResponse>;
    aiPrompt?: string;
}
export namespace ManagementClientTagRequest {
    export type TagTypeEnum = 'CLIPPING' | 'TRANSCRIPTION' | 'CONTRACT_NOTICES';
    export const TagTypeEnum = {
        CLIPPING: 'CLIPPING' as TagTypeEnum,
        TRANSCRIPTION: 'TRANSCRIPTION' as TagTypeEnum,
        CONTRACTNOTICES: 'CONTRACT_NOTICES' as TagTypeEnum
    };
    export type BrandKindEnum = 'COMPANY' | 'COMPETITOR';
    export const BrandKindEnum = {
        COMPANY: 'COMPANY' as BrandKindEnum,
        COMPETITOR: 'COMPETITOR' as BrandKindEnum
    };
}